"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconRetry = function SvgIconRetry(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "retry icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Retry Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.454 22.087l-6.582 6.378a1.952 1.952 0 01-1.356.546 1.952 1.952 0 01-1.357-.546l-6.581-6.378a1.76 1.76 0 01.022-2.57 1.971 1.971 0 012.69.017l3.68 3.564c-.476-6.592-6.149-11.825-13.061-11.825-7.222 0-13.098 5.71-13.098 12.727 0 7.018 5.876 12.727 13.098 12.727a13.27 13.27 0 007.396-2.222 1.963 1.963 0 012.654.45 1.768 1.768 0 01-.473 2.532 17.207 17.207 0 01-9.577 2.877C11.585 40.364 4 33.022 4 24c0-9.022 7.585-16.364 16.909-16.364 8.782 0 16.018 6.51 16.828 14.808l3-2.909a1.971 1.971 0 012.692-.019c.753.702.763 1.855.021 2.571"
  }));
};

var _default = SvgIconRetry;
exports.default = _default;